/* eslint-disable */
<template>
  <div class="booking-requests">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Booking Requests</h1></div>
        <div class="header-sub-title">Booking Requests, including Supplementary Requests submitted by, or acting on behalf of, a Client, for action by Red Health.</div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu indexProps="1" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input clearable class="search-input w-15 filter-icon right-float-element mr-5 clear" placeholder="Assigned to" @input="search()" v-model="listParam.AssignedTo" />
            <el-input clearable class="search-input w-15 filter-icon right-float-element mr-5 clear" placeholder="Specialist" @input="search()" v-model="listParam.SpecialistName" />
            <el-input clearable class="search-input w-15 filter-icon right-float-element mr-5 clear" placeholder="Client" @input="search()" v-model="listParam.ClientName" />
            <div class="icon-group right-float-element">
              <router-link :to="{ name: 'admin-manage-booking-request', query: {} }">
                <v-btn class="add-icon" dark>Add New</v-btn>
              </router-link>
            </div>
          </div>
        </div>

        <div v-if="fetchedData" class="content-scroll-x">
          <div>
            <div>
              <el-table @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'DateSubmitted', order: 'descending'}" stripe @sort-change="sortParam" :data="bookingRequests" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="180"
                    prop="Client"
                    label="Requesting Client"
                    sortable="custom"
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.Client.ClientName + ' - ' +  booking.row.Client.BranchName) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    prop="requirements"
                    label="Requirements"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{decodeURIComponent(scope.row.BookingRequestPersonConditions ? scope.row.BookingRequestPersonConditions.map(item => item.ConditionName).join(','): '')}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    prop="claimantFullName"
                    label="Examinee Name"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{getClaimantFullName(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    prop="qualificationList"
                    label="Specialty"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{scope.row.Specialist ? scope.row.Specialist.Qualifications.map(item => item.QualificationName).join(','): ''}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    prop="Specialist"
                    label="Specialist"
                    sortable="custom"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{getSpecialistFullName(scope.row.Specialist)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="160"
                    prop="fullLocation"
                    label="Location/Region"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{getLocation(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="220"
                    prop="DateSubmitted"
                    sortable="custom"
                    label="Date Range"
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <span>{{ formatDate(booking.row.DateFrom, 'DD/MM/YYYY') + (booking.row.DateTo != '' ? ' - ' + formatDate(booking.row.DateTo, 'DD/MM/YYYY') : '') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    prop="DateSubmitted"
                    label="Submitted"
                    sortable="custom"
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <span>{{ formatDate(booking.row.DateSubmitted, 'DD/MM/YYYY hh:mm A', 'YYYY-MM-DD HH:mm:ss.ssssss') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    prop="Status"
                    label="Status"
                    sortable="custom"
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <select class="w-100 textbox" v-model="booking.row.BookingRequestStatus" @change="changeBookingRequestStatus(booking.$index)">
                      <option hidden value="">Select ...</option>
                      <option v-for="(bookingRequest, index) in bookingRequestStatuses" :key="bookingRequest.id" :value="bookingRequest.id">{{ bookingRequest.name }}</option>
                    </select>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    prop="AssignedTo"
                    label="Assigned To"
                    sortable="custom"
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <el-select class="w-100" :loading="loading" filterable  placeholder="Select..." v-model="booking.row.AssignedTo" @change="changeAssignedTo(booking.$index)">
                      <el-option v-for="(user, index) in users" :key="index" :value="user.id" :label="user.name">{{ user.name }}</el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    prop="requirements"
                    label=""
                    show-overflow-tooltip
                >
                  <template slot-scope="booking">
                    <div class="icon-group">
                      <span data-placement="right" data-toggle="tooltip" :title="booking.row.note"><img :src="booking.row.note == '' ? require('@/assets/images/note_light_icon.svg') : require('@/assets/images/note_dark_icon.svg')"/></span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import AdminBookingsMenu from '@/components/AdminBookingsMenu'
  import Header from '@/components/Header'
  import { debounce } from 'lodash'

  export default {
    name: 'AdminBookingRequests',
    components: {
      AdminNavigation,
      AdminBookingsMenu,
      Header,
    },
    data() {
      return {
        fetchedData: false,
        successMessage: '',
        debounceGet: null,
        bookingRequests: [],
        limit: 10,
        pagination: utilities.initPagination(),
        userParam: {
          pageSize: 999,
          pageNum: 1,
          orderBy: 'UserStatus',
          ascOrDesc: 'DESC',
          UserName: null,
          UserRoleID: '3,6'
        },
        byClient: false,
        byRequirement: false,
        bySpecialty: false,
        bySpecialist: false,
        byLocation: false,
        byDate: false,
        bySubmitted: false,
        byStatus: false,
        byAssignedTo: false,
        regionLocations: [],
        searchAssignedTo: '',
        searchSpecialist: '',
        searchClient: '',
        loading: false,
        users: [],
        listParam: {
          pageSize: 10,
          pageNum: 1,
          sortBy: 'DateSubmitted',
          AssignedTo: "",
          SpecialistName: "",
          ClientName: "",
          ascOrDesc: 'DESC',
        },
        totalCount: 0,
        bookingRequestStatuses: [],
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
    },
    methods: {

      getLocation(item) {
        let locationValue = []
        if (item.StateID) {
          const state = this.regionLocations.find(i => i.id === 's'+item.StateID)
          locationValue.push(state ? state.label : '')
          if (item.RegionID && state) {
            const region = state.children.find(i => i.id === 'r'+item.RegionID)
            locationValue.push(region ? region.label : '')
          }
          return locationValue.join('/')
        }
        return locationValue.join('/')
      },
      getClaimantFullName(claimant) {
        return utilities.getClaimantFullNameUpper(claimant);
      },
      getSpecialistFullName(specialist) {
        return utilities.getSpecialistFullNameUpper(specialist);
      },
      async remoteMethod(query) {
        this.userParam.UserName = query
        this.loading = true
        await this.loadData(true)
        this.loading = false
      },
      sortParam( v ) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },
      RowClick(row, col) {
        if(col.property === 'AssignedTo' || col.property === 'Status') return
        this.openBookingRequest(row?.BookingRequestID)
      },
      async selectPage(index) {
        this.listParam.pageNum = index
        await this.loadBookingRequests()
      },
      search: debounce(function(){
        // 执行内容...
        this.listParam.pageNum = 1
        this.loadBookingRequests()
      },800),

      openBookingRequest(id) {
        this.$router.push({ name: 'admin-booking-request-form', query: { id: id } })
      },
      formatDate(dateToFormat, newFormat, currentFormat) {
        return utilities.formatDate(dateToFormat, newFormat, currentFormat)
      },
      async changeBookingRequestStatus(index) {
        console.log(index)
        this.$store.dispatch('loading/setLoadComponent', true)
        if(this.bookingRequests[index].status != 1 && this.bookingRequests[index].assignedTo === '') {
          // Assigned to person who logged in
          this.bookingRequests[index].assignedTo = this.user.id
        }
        const result = await this.putBookingRequest(index)
        if (result) {
          this.successMessage = 'Booking request updated successfully.'
          utilities.showAlert('.alert-success')
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },
      async changeAssignedTo(index) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        // Change status to assigned
        this.bookingRequests[index].status = 2
        const result = await this.putBookingRequest(index)
        if (result) {
          this.successMessage = 'Booking request updated successfully.'
          utilities.showAlert('.alert-success')
        }
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      putBookingRequest(index) {
        var params = {}
        if(Number(this.bookingRequests[index].AssignedTo)) {
          params.AssignedTo = Number(this.bookingRequests[index].AssignedTo)
        }
        if(Number(this.bookingRequests[index].BookingRequestStatus)) {
          params.BookingRequestStatus = Number(this.bookingRequests[index].BookingRequestStatus)
        }

        var callback = (response) => {
          // Reload if change to Completed
        }
        return utilities.putBookingRequest(this.bookingRequests[index].BookingRequestID, params, callback)
      },

      async loadBookingRequests() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        let {bookingRequests, total} = await utilities.getBookingRequestsNew(this.listParam)
        this.totalCount = total
        // Show all not been completed yet
        this.bookingRequests = _.cloneDeep(bookingRequests)
        this.bookingRequests.filter(item => item.assignedTo).forEach(item => {
          if(this.users.filter(user => user.id === item.assignedTo).length === 0) {
            this.users.push({id: item.assignedTo, name: decodeURIComponent(item.assignedToName)})
          }
        })
        this.bookingRequestStatuses = utilities.getBookingRequestStatuses()
        console.log(this.bookingRequests)
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      async loadData() {
        var {users} = await utilities.getUsersNew(this.userParam)
        this.users = users.filter(item => item.status)
      },
    },

    async beforeMount() {
      $('body>.tooltip').remove()
      const arr = [utilities.getRegions(), utilities.getLocations()]
      Promise.all(arr).then(r => {
        this.regionLocations = utilities.getRegionLocations(r[0], r[1], true)
        console.log(this.regionLocations)
      })
      await this.loadData()
      await this.loadBookingRequests()
      this.fetchedData = true
    }
  }
</script>
